const BASE_URL = 'https://admin-api.afaqtel.ir';
// const BASE_URL = 'http://localhost:5000';
export const STATIC_URL = 'https://admin-api.afaqtel.ir/files/';
// export const STATIC_URL = 'http://localhost:5000/files/';
export const SIGN_IN_URL = BASE_URL + '/auth/signin';
export const USERS_URL = BASE_URL + '/auth/users';
export const UPLOAD_EXCEL_URL = BASE_URL + '/admin-4jxlqTk1b/insert-device-excel';
export const DEVICE_OVERALL_URL = BASE_URL + '/admin-4jxlqTk1b/device-overall-info';
export const DEVICE_MODELS_URL = BASE_URL + '/models';
export const DEVICES_URL = BASE_URL + '/devices';
export const FORCE_REGISTER_URL = BASE_URL + '/admin-4jxlqTk1b/register-device';
export const BRANDS_URL = BASE_URL + '/models/brands';
